module.exports = __webpack_public_path__ + "static/media/36.a0cbd3a7.wav";